module.exports = __webpack_public_path__ + "img/avatar-s-1.3fdebd01.jpg";